let baseUrl = "https://jgsyxcx.fzu.edu.cn/api";
//let baseUrl = "http://localhost:44365//api";

import axios from 'axios'
import {
	Decrypt,
	EntityEncrypt
} from './secret'

const getApi = (url, datas = {}, types = "GET") => {
	return new Promise(function (r, s) {
		axios({
			url: `${baseUrl}${url}`,
			data: 'DataStr=' + EntityEncrypt(datas),
			method: types,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
			}
		}).then(function (res) {
			if (res.data.IsSuccess && res.data.SuccessData != null) {
				res.data.SuccessData = JSON.parse(Decrypt(res.data.SuccessData))
			}
			r(res.data)
		}).catch(function (err) {
			s(err)
		});
	})
}


export {
	getApi
};
